let googleMapsLoaded = false;
let googleMapsPromise: Promise<void> | null = null;

export const loadGoogleMaps = (): Promise<void> => {
  // If already loaded, return resolved promise
  if (googleMapsLoaded) {
    return Promise.resolve();
  }

  // If currently loading, return existing promise
  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  // Start loading
  googleMapsPromise = new Promise((resolve, reject) => {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps) {
      googleMapsLoaded = true;
      resolve();
      return;
    }

    const apiKey = window.RUNTIME_CONFIG?.VITE_GOOGLE_MAPS_API_KEY || import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    if (!apiKey) {
      reject(new Error('Google Maps API key is not configured'));
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker,geometry&loading=async&v=3.61`;
    script.async = true;

    // Timeout after 30 seconds
    const timeout = setTimeout(() => {
      script.onload = null;
      script.onerror = null;
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      googleMapsPromise = null;
      reject(new Error('Google Maps API loading timed out after 30 seconds'));
    }, 30000);

    script.onload = () => {
      clearTimeout(timeout);
      googleMapsLoaded = true;
      resolve();
    };

    script.onerror = () => {
      clearTimeout(timeout);
      googleMapsPromise = null;
      reject(new Error('Failed to load Google Maps API'));
    };

    document.head.appendChild(script);
  });

  return googleMapsPromise;
};